/* The habit library — every habit as a tile, in the one shared order (drag
   to arrange); a tile opens its sheet, where Edit holds the delete. */
import { addDaysStr, todayStr, useStore } from '@habishine/client-core';

import { Icon } from '../components/Icon';
import { HabitTile } from '../components/rows';
import { SortableList } from '../components/Sortable';
import { SunMark } from '../components/SunMark';
import { Button, Page, PageHeader } from '../components/ui';
import { useEditors } from '../shell/Editors';

export function HabitsPage() {
  const { habitsForDay, moveHabit, pinnedIdFor, completeItem, state } = useStore();
  const { editHabit, openHabit } = useEditors();
  const today = todayStr();
  const habits = habitsForDay(today);
  const pinnedId = pinnedIdFor(today);
  const weekDays = Array.from({ length: 7 }, (_, i) => addDaysStr(today, i - 6));

  return (
    <Page className="screen-in">
      <PageHeader
        hue="teal"
        eyebrow="Your library"
        title="Habits"
        sub="The kind of person you're becoming, one small rep at a time. Drag to arrange — Today follows this order."
        right={<Button variant="primary" onClick={() => editHabit(null)}><Icon name="plus" size={16} strokeWidth={2.6} /> New habit</Button>}
      />
      {habits.length === 0 ? (
        <div className="rise-in surface mt-2 flex flex-col items-center px-6 py-16 text-center">
          <span className="sun-glow"><SunMark size={56} /></span>
          <div className="font-display mt-5 text-[28px] font-semibold text-ink">Start with something tiny.</div>
          <div className="mt-1.5 max-w-[36ch] text-[14.5px] leading-[1.5] text-meta">Two minutes counts. “After I pour my coffee, I will read one page.” The rep is what matters; the size comes later.</div>
          <Button variant="primary" className="mt-6" onClick={() => editHabit(null)}><Icon name="plus" size={16} strokeWidth={2.6} /> Your first habit</Button>
        </div>
      ) : (
        <SortableList
          items={habits}
          layout="grid"
          className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-4"
          onMove={(from, to) => moveHabit(habits, from, to)}
          render={(h, i) => <HabitTile habit={h} index={i} pinned={h.id === pinnedId} onOpen={() => openHabit(h.id, today)} onCheckIn={() => completeItem(h.id, today)} weekDays={weekDays} checkins={state.checkins[h.id]} />}
        />
      )}
    </Page>
  );
}
